{
  "salon-search-container": {
    "text": {
      "find-salon": "Tìm tiệm của bạn",
      "find-salon-hint": "Vui lòng chọn thành phố của tiệm cần tìm"
    }
  }
}
